import React, { useState } from "react";
import { Box, Typography, Grid, TextField, MenuItem } from "@mui/material";
import styles from "./PostRequirement.module.css";

const job_type = [
  {
    value: "Full_Time",
    label: "Full Time",
  },
  {
    value: "Contract",
    label: "Contract",
  },
  {
    value: "Contact_To_Hire",
    label: "Contact To Hire",
  },
  {
    value: "W2",
    label: "W2",
  },
  {
    value: "1099",
    label: "1099",
  },
];

const location = [
  {
    value: "PST",
    label: "PST",
  },
  {
    value: "CST",
    label: "CST",
  },
  {
    value: "EST",
    label: "EST",
  },
  {
    value: "MST",
    label: "MST",
  },
];

export default function SearchJobPost(props) {
  const [showMore, setShowMore] = useState(false);

  const { filter, handleInputChange, handleOnSearch, handleOnClear } = props;
  return (
    <Box sx={{ backgroundColor: "#fff", padding: '20px 5px 5px 10px '}}>
      <Grid container>
        {/* <Grid item xs={12} sm={6} md={1.6} lg={1.6} sx={{ padding: '0 10px' }}>
                    <Box>
                        <Typography>BDM Name</Typography>
                        <TextField
                            id="outlined-select-currency"
                            type="text"
                            defaultValue="Enter Name"
                            size="small"
                            sx={{ backgroundColor: "#fff", width: "100%" }}
                        />
                    </Box>
                </Grid> */}
        <Grid item xs={12} sm={6} md={1.6} lg={1.6} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>Job Title</Typography>
            <TextField
              id="outlined-select-currency"
              type="text"
              size="small"
              name="jobTitle"
              value={filter.jobTitle}
              onChange={handleInputChange}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={1.6} lg={1.6} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>Job Type</Typography>
            <TextField
              id="outlined-select-currency"
              select
              defaultValue="W2"
              size="small"
              name="jobType"
              value={filter.jobType}
              onChange={handleInputChange}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            >
              {job_type.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Grid>
         <Grid item xs={12} sm={6} md={1.6} lg={1.6} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>Time Zone</Typography>
            <TextField
              id="outlined-select-currency"
              select
              defaultValue="Select"
              size="small"
              name="location"
              value={filter.location}
              onChange={handleInputChange}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            >
              {location.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={1.6} lg={1.6} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>Location</Typography>
            <TextField
              id="outlined-select-currency"
              select
              defaultValue="Select"
              size="small"
              name="location"
              value={filter.location}
              onChange={handleInputChange}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            >
              {location.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={1.6} lg={1.6} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>From Date</Typography>
            <TextField
              id="outlined-basic"
              type="date"
              variant="outlined"
              size="small"
              name="formDate"
              value={filter.formDate}
              onChange={handleInputChange}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={1.6} lg={1.6} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>To date</Typography>
            <TextField
              id="outlined-basic"
              type="date"
              variant="outlined"
              size="small"
              name="toDate"
              value={filter.toDate}
              onChange={handleInputChange}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            />
          </Box>
        </Grid>
    
        <Grid
          item
          xs={12}
          sm={6}
          md={2.4}
          lg={2.4}
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "end",
            padding: "10px 10px 0 10px",
          }}
        >
          <Box className={styles.search_btn}>
          <span className={styles.search_post_btn}>
            <button
              variant="contained"
              style={{ backgroundColor: "#3856a6", marginRight: "10px" }}
              onClick={handleOnSearch}
            >
              Search
            </button>
            </span>
            <button
              variant="contained"
              style={{ backgroundColor: "#4285f4" }}
              // onClick={() => setShowMore(!showMore)}
              onClick={handleOnClear}
            >
              {showMore ? "Less" : "Clear"}
            </button>
         
          </Box>
        </Grid>
      </Grid>

      {/* {showMore && (
        <Grid container sx={{ marginTop: "20px" }}>
          <Grid
            item
            xs={12}
            sm={6}
            md={1.6}
            lg={1.6}
            sx={{ padding: "0 10px" }}
          >
            <Box>
              <Typography>BDM Name</Typography>
              <TextField
                id="outlined-select-currency"
                type="text"
                defaultValue="Enter Name"
                size="small"
                sx={{ backgroundColor: "#fff", width: "100%" }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={1.5}
            lg={1.5}
            sx={{ padding: "0 5px" }}
          >
            <Box>
              <Typography>Job Title</Typography>
              <TextField
                id="outlined-select-currency"
                type="text"
                defaultValue="Enter"
                size="small"
                sx={{ backgroundColor: "#fff", width: "100%" }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={1.6}
            lg={1.6}
            sx={{ padding: "0 5px" }}
          >
            <Box>
              <Typography>Job Type</Typography>
              <TextField
                id="outlined-select-currency"
                select
                defaultValue="Select"
                size="small"
                sx={{ backgroundColor: "#fff", width: "100%" }}
              >
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={1.6}
            lg={1.6}
            sx={{ padding: "0 5px" }}
          >
            <Box>
              <Typography>Location</Typography>
              <TextField
                id="outlined-select-currency"
                select
                defaultValue="Select"
                size="small"
                sx={{ backgroundColor: "#fff", width: "100%" }}
              >
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={1.6}
            lg={1.6}
            sx={{ padding: "0 5px" }}
          >
            <Box>
              <Typography>From Date</Typography>
              <TextField
                id="outlined-basic"
                type="date"
                variant="outlined"
                size="small"
                sx={{ backgroundColor: "#fff", width: "100%" }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={1.6}
            lg={1.6}
            sx={{ padding: "0 5px" }}
          >
            <Box>
              <Typography>To date</Typography>
              <TextField
                id="outlined-basic"
                type="date"
                variant="outlined"
                size="small"
                sx={{ backgroundColor: "#fff", width: "100%" }}
              />
            </Box>
          </Grid>
        </Grid>
      )} */}
    </Box>
  );
}
